import { QueryKey } from '../hooks/QueryKey';

import { toast } from '@baseball-near-you/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clients } from '../clients';

export function useUserTeamInterestMutation() {
  const queryClient = useQueryClient();
  const {
    mutateAsync: createUserTeamInterest,
    isLoading: creatingUserTeamInterest,
    error: userTeamInterestError,
  } = useMutation({
    mutationFn: ({
      userId,
      teamId,
    }: {
      userId: string;
      teamId: number;
    }) => {
      return clients.user.createUserTeamInterest({
        args: { id: userId },
        payload: {
          teamId,
        },
      });
    },
    onSuccess: async (u) => {
      await queryClient.invalidateQueries([QueryKey.User]);
      toast.success('You are now signed up to be notified!', {
        description:
          'You will receive an email when this team has been claimed by an official member of this organization.',
        duration: 10000,
      });
    },
    onError: (error: { message?: string }) => {
      toast.error('There was an error updating your profile.', {
        description: error?.message ?? 'Please try again later',
      });
    },
  });
  return {
    createUserTeamInterest,
    creatingUserTeamInterest,
    userTeamInterestError,
  };
}
